<div *ngIf="isLoading | async" class="overlay">
  <img src="assets/img/loading3.gif" class="imagem">
</div>
